import {
  CLAIM_ERROR,
  CLAIM_REQUESTING,
  CLAIM_SUCCESS,
  DISABLE_INPUTS
} from './claim-constants'
import type { ClaimDetailsType, FetchClaimArgs } from './types'

const fetchClaim = ({ claimNumber, dateOfLoss, recaptchaToken }: FetchClaimArgs) => ({
  type: CLAIM_REQUESTING,
  claimNumber,
  dateOfLoss,
  recaptchaToken
})

const claimError = (error?: unknown) => ({ type: CLAIM_ERROR, error })
const claimSuccess = (claimDetails: ClaimDetailsType) => ({ type: CLAIM_SUCCESS, claimDetails })
const disableInputs = () => ({ type: DISABLE_INPUTS, disable: true })
const enableInputs = () => ({ type: DISABLE_INPUTS, disable: false })

export {
  claimError,
  claimSuccess,
  disableInputs,
  enableInputs,
  fetchClaim
}
